"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./blindModal.sass");

var _Portal = _interopRequireDefault(require("../Portal"));

var _Hotkey = _interopRequireDefault(require("../Hotkey"));

var BlindModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BlindModal, _Component);

  function BlindModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BlindModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BlindModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      closed: true,
      isClosing: false,
      isOpening: false,
      isTransitionRunning: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "close", function () {
      if (!_this.state.isTransitionRunning) {
        _this.setState({
          isClosing: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderChildren", function () {
      return _this.props.children;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderContent", function () {
      var width = _this.props.width;
      var style = width ? {
        width: width
      } : null;
      return _react.default.createElement("div", {
        className: "blindModal-content",
        style: style
      }, !_this.state.closed && _this.renderChildren());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onTransitionEnd", function () {
      var onClose = _this.props.onClose;
      var isClosing = _this.state.isClosing;

      if (isClosing) {
        _this.setState({
          closed: true,
          isClosing: false,
          isOpening: false,
          isTransitionRunning: false
        });

        onClose && onClose();
      } else {
        _this.setState({
          isTransitionRunning: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(BlindModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!this.state.closed && !this.state.isOpening) {
        setImmediate(function () {
          _this2.setState({
            isOpening: true,
            isTransitionRunning: true
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var closed = this.state.closed;

      if (closed) {
        return null;
      }

      return _react.default.createElement(_Portal.default, {
        onTransitionEnd: this.onTransitionEnd,
        onAnimationStart: this.onAnimationStart,
        className: this.classnames
      }, _react.default.createElement("div", {
        className: "blindModal-blackout",
        onClick: this.close
      }), _react.default.createElement(_Hotkey.default, {
        shortcut: "esc",
        action: this.close
      }), this.renderContent());
    }
  }, {
    key: "classnames",
    get: function get() {
      var _this$props = this.props,
          className = _this$props.className,
          large = _this$props.large,
          width = _this$props.width;
      var _this$state = this.state,
          isOpening = _this$state.isOpening,
          isClosing = _this$state.isClosing;
      return (0, _classnames.default)('blindModal', className, {
        'blindModal--large': !width && !!large,
        'blindModal--customWidth': !!width,
        'blindModal--opened': isOpening,
        'blindModal--closing': isClosing
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.opened && prevState.closed) {
        return {
          closed: false,
          isClosing: false
        };
      }

      if (nextProps.opened === false) {
        return {
          isClosing: true
        };
      }

      return null;
    }
  }]);
  return BlindModal;
}(_react.Component);

exports.default = BlindModal;
BlindModal.propTypes = process.env.NODE_ENV !== "production" ? {
  opened: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func,
  large: _propTypes.default.bool,
  width: _propTypes.default.string
} : {};